// Client for RSVP event status. Talks to the serverless functions in api/,
// which hold the Upstash token server-side. The browser never sees a database
// credential. See docs/ARCHITECTURE.md.
//
// In production (Vercel) the api/ routes are served from the same origin, so a
// relative "/api/..." path works. For local development you can either run
// `vercel dev` (which serves api/ alongside the app) or point REACT_APP_API_BASE
// at a deployment that has them.

import { API_BASE } from '../config/api';

export async function fetchEventStatus(slug) {
  try {
    const resp = await fetch(`${API_BASE}/api/event-status?slug=${encodeURIComponent(slug)}`);
    if (!resp.ok) return null;
    const data = await resp.json().catch(() => null);
    if (!data || data.error) return null;
    return data; // { slug, capacity, sold, remaining }
  } catch (_) {
    return null;
  }
}

export async function incrementRSVP(slug, count) {
  try {
    const resp = await fetch(`${API_BASE}/api/event-increment`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ slug, increment: Number(count) }),
    });
    const data = await resp.json().catch(() => null);
    // 409 = would exceed capacity (event full). Surface it so the UI can react.
    if (resp.status === 409) {
      return {
        error: (data && data.error) || 'Event is full',
        slug,
        sold: data && data.sold,
        capacity: data && data.capacity,
        remaining: data && data.remaining,
      };
    }
    if (!resp.ok || !data || data.error) {
      return data && data.error ? { error: data.error, slug } : null;
    }
    return data; // { slug, sold }
  } catch (_) {
    return null;
  }
}
